import eventBus from '../../../../services/eventBus'
import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'

const created = (group: IParameterGroup) => {
  eventBus.pub('parameter.group.created', group)
}

const updated = (group: IParameterGroup) => {
  eventBus.pub('parameter.group.updated', group)
}

const deleted = (id: IParameterGroup['id']) => {
  eventBus.pub('parameter.group.deleted', id)
}

const parameterGroupsEvents = { created, updated, deleted }
export default parameterGroupsEvents
